export default function mask(){
    $(document).ready(function(){
        $("#phone").mask("(00) 00000-0000");
    });

    $(document).ready(function(){
        $("#cpf").mask("000.000.000-00");
    });

    $(document).ready(function(){
        $("#cep").mask("00000-000");
    });

    $(document).ready(function(){
        $("#date").mask("00/00/0000");
    });
}